import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, AlertCircle } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function Verify() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { signIn } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setError("No token provided.");
      return;
    }
    api
      .post("/auth/verify", { token })
      .then(({ data }) => {
        signIn(data.token, data.user);
        nav("/dashboard", { replace: true });
      })
      .catch((err) => setError(apiError(err)));
  }, [params, nav, signIn]);

  return (
    <div className="min-h-screen grid place-items-center px-6">
      {error ? (
        <div className="max-w-md text-center animate-fade-up" data-testid="verify-error">
          <span className="grid place-items-center w-14 h-14 rounded-full bg-amber-50 text-amber-500 mx-auto mb-5"><AlertCircle size={28} /></span>
          <Logo />
          <h1 className="font-heading font-black text-2xl text-ink mt-6">Link couldn't be used</h1>
          <p className="text-slate-600 mt-3">{error}</p>
          <button onClick={() => nav("/login")} className="mt-6 bg-brand hover:bg-brand-hover text-white font-semibold px-5 py-3 rounded-lg transition-colors">
            Request a new link
          </button>
        </div>
      ) : (
        <div className="text-center">
          <Loader2 className="animate-spin text-brand mx-auto" size={34} />
          <p className="text-slate-600 mt-4 font-medium">Signing you in…</p>
        </div>
      )}
    </div>
  );
}
